import { Columns, LoadingModule } from '@domain-group/suit-theme'

import useCampaignQuoteTemplate from '@hooks/useCampaignQuoteTemplate'

import useQuoteTemplateBuilder from '@components/QuoteBuilder/components/QuoteTemplateBuilder/hooks/useQuoteTemplateBuilder'
import QuoteTemplateBuilder from '@components/QuoteBuilder/components/QuoteTemplateBuilder'

import CampaignQuoteTemplateTools from '../../../../components/CampaignQuoteTemplateTools'
import PageLayout from '../../../../components/PageLayout'

import DataSourceChangedNotice from '../DataSourceChangedNotice'
import QuoteDataSource from '../QuoteDataSource'

interface PageContentProps {
  agencyId: number,
  campaignQuoteTemplateId: number,
}

const PageContent = (props: PageContentProps) => {
  const { agencyId, campaignQuoteTemplateId } = props

  const campaignQuoteTemplatePayload = useCampaignQuoteTemplate({ id: campaignQuoteTemplateId }, {
    generateUrlsOptions: {
      prefixRoute: `agencies/${agencyId}/manage`,
    },
  })

  const {
    campaignQuoteTemplate,
    loading,
    updating,
  } = campaignQuoteTemplatePayload

  const quoteTemplateBuilderPayload = useQuoteTemplateBuilder({
    campaignQuoteTemplateId,
    generateUrlsOptions: {
      prefixRoute: `agencies/${campaignQuoteTemplate.agency_id}/manage`,
    },
  })

  const {
    callbacks: {
      recalculateQuoteTemplatePrices,
      setSelectedCampaignId,
    },
    manuallyUpdatedCampaign,
    selectedCampaign,
    selectedCampaignId,
  } = quoteTemplateBuilderPayload

  return (
    <PageLayout activeTabBarItemKey="editor" campaignQuoteTemplatePayload={campaignQuoteTemplatePayload}>
      <Columns.Main>
        <LoadingModule loading={loading} times={3} />

        {manuallyUpdatedCampaign && (
          <DataSourceChangedNotice
            callbacks={{ recalculateQuoteTemplatePrices }}
            updating={updating}
          />
        )}

        <QuoteTemplateBuilder quoteTemplateBuilderPayload={quoteTemplateBuilderPayload} />
      </Columns.Main>

      <Columns.Sidebar>
        <QuoteDataSource
          callbacks={{
            setSelectedCampaignId,
          }}
          // @ts-expect-error TS2740
          selectedCampaign={selectedCampaign}
          // @ts-expect-error TS2322
          selectedCampaignId={selectedCampaignId}
        />

        <CampaignQuoteTemplateTools
          campaignQuoteTemplatePayload={campaignQuoteTemplatePayload}
        />
      </Columns.Sidebar>
    </PageLayout>
  )
}

export default PageContent
